import React from 'react';
import { Link } from 'react-router-dom';
import { HeartIcon, HandshakeIcon } from 'lucide-react';
export function DonateSection() {
  return <section id="donar" className="relative py-24 px-4 sm:px-6 lg:px-8 overflow-hidden flex items-center" style={{
    minHeight: '500px'
  }} data-id="element-56" data-mp="2tdqgn0aty84">
      <div className="absolute inset-0" data-id="element-57" data-mp="br64lnuaaztx">
        <img src="https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=1200" alt="Manos unidas en apoyo" className="w-full h-full object-cover" data-id="element-58" data-mp="bqebcjo5te6t" />
        <div className="absolute inset-0 bg-primary/80" data-id="element-59" data-mp="lk4vjcd972gp" />
      </div>
      <div className="relative max-w-4xl mx-auto text-center" data-id="element-60" data-mp="zgigivgzxlzx">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-61" data-mp="vfoqnwjztx4e">
          Sé Parte del Cambio
        </h2>
        <p className="text-xl text-white/95 mb-8 max-w-3xl mx-auto" data-id="element-62" data-mp="319y4tlpm2orq">
          Tu apoyo elimina las barreras económicas que separan a familias con
          niños neurodiversos de la educación, orientación y recursos que
          necesitan. Juntos construimos oportunidades reales.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-63" data-mp="1ms6s689zeo2p">
          <Link to="/donar" className="inline-flex items-center justify-center gap-2 bg-white text-primary px-10 py-5 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors shadow-xl hover:shadow-2xl" data-id="element-64" data-mp="1rpq6f86oj0un">
            <HeartIcon className="w-6 h-6" data-id="element-65" data-mp="21fruw12y2la3" />
            DONAR AHORA
          </Link>
          <Link to="/quiero-ser-aliado" className="inline-flex items-center justify-center gap-2 border-2 border-white text-white px-10 py-5 rounded-lg font-bold text-lg hover:bg-white hover:text-primary transition-colors" data-id="element-66" data-mp="25gbowvs818s0">
            <HandshakeIcon className="w-6 h-6" data-id="element-67" data-mp="g2yj124gncos" />
            Ser Aliado Corporativo
          </Link>
        </div>
      </div>
    </section>;
}